import styled from 'styled-components';

export const ConfirmationSuccessStyle = styled.div`
  .succes-info {
    text-align: left;
  }
`;
